


































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { getSnackbarMessage, minutesToHours, maskDate } from '@/utils/common'
import { CirurgiaConjuntaTriagemItem, CirurgiaConjuntaTriagemSolicitacao } from '@/types/interfaces/CirurgiaConjunta'

@Component
export default class ComponentBackofficeCirurgiasConjuntasAssociadas extends Vue {
  cirurgiasConjuntas: CirurgiaConjuntaTriagemItem[] = []

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  tableHeaders = [
    { text: '', value: 'expandir', sortable: false, width: '24px' },
    { text: 'Procedimento', value: 'procedimento', sortable: false },
    { text: 'Médico executante', value: 'medicoExecutante', sortable: false },
    { text: 'Tempo (min)', value: 'tempo', sortable: false },
    { text: 'Equipamentos da cirurgia associada', value: 'equipamentos', sortable: false },
    { text: '', value: 'acoes', sortable: false },
  ]

  get cirurgiasComSolicitacao() {
    return this.cirurgiasConjuntas.filter(item => !!item.solicitacao)
  }

  get tempoTotalMinutos() {
    return this.cirurgiasComSolicitacao.reduce((total, item) => total + (item.solicitacao!.tempoCirurgia || 0), 0)
  }

  get tempoTotalFormatado() {
    return minutesToHours(this.tempoTotalMinutos)
  }

  formatarDataPrevista(data: string | null | undefined) {
    return data ? maskDate(data) : '-'
  }

  labelDataPrevista(solicitacao: CirurgiaConjuntaTriagemSolicitacao) {
    return solicitacao.dataAgendamento ? 'Data agendada' : 'Data prevista'
  }

  visualizarSolicitacaoDaLinha(item: CirurgiaConjuntaTriagemItem) {
    const solicitacaoId = item.solicitacao && item.solicitacao.id

    if (!solicitacaoId) {
      return
    }

    const { href } = this.$router.resolve({ name: 'backoffice-surgery-solicitation-details', params: { solicitacaoId } })
    window.open(href, '_blank')
  }

  mounted() {
    this.buscarCirurgiasConjuntasDaTriagem()
  }

  async buscarCirurgiasConjuntasDaTriagem() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id

    if (!solicitacaoId) {
      return
    }

    const response = await Apis.Agendamento.CirurgiaConjuntaApi.getCirurgiaConjuntaTriagem(solicitacaoId)

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar as cirurgias conjuntas associadas.', 'error'))
      return
    }

    this.cirurgiasConjuntas = (response.data && response.data.cirurgiaConjunta) || []
  }
}
